import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroContactRequestForm.AddressPart', {
    attention: 'Attention',
    attentionPlaceholder: 'Enter Attention',
    address: 'Address',
    addressPlaceholder: 'Enter Address',
    city: 'City/town',
    cityPlaceholder: 'Enter City/town',
    state: 'State/region',
    statePlaceholder: 'Enter State/region',
    postalCode: 'Postal code/ZIP code',
    postalCodePlaceholder: 'Enter Postal code/ZIP code',
    country: 'Country',
    countryPlaceholder: 'Enter Country',
});
